import { render, staticRenderFns } from "./modifydate.vue?vue&type=template&id=2b090c86"
import script from "./modifydate.vue?vue&type=script&lang=js"
export * from "./modifydate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports